module.exports = __webpack_public_path__ + "img/ed63cf5a335540f407a0545a97a6e3c7.png";